import {Component} from "@angular/core";
import {ViewController} from "ionic-angular/index";

@Component({
  templateUrl: 'pricing-modal.component.html'
})
export class PricingModal {
  constructor(private viewCtrl:ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/pricing-modal/pricing-modal.component.ts